export default "__VITE_ASSET__B$Qq3$ok__"